import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import { useAuth } from './AuthContext';
import { initSampleData } from '../utils/storage';

const GymInfraContext = createContext(null);

export const GymInfraProvider = ({ children, adminGymId = null }) => {
  const { isDemoMode, gym } = useAuth();
  const isAdminMode = !!adminGymId;
  const gymId = adminGymId ?? gym?.id ?? null;
  const useDB = !isDemoMode && !!gymId;

  // reloadTrigger: importBackup 등에서 전체 리로드를 유발
  const [reloadTrigger, setReloadTrigger] = useState(0);
  const triggerReload = useCallback(() => setReloadTrigger(c => c + 1), []);

  // 데모 모드 샘플 데이터 초기화 (한 번만)
  const [sampleInited, setSampleInited] = useState(false);
  useEffect(() => {
    if (isDemoMode && !sampleInited) {
      initSampleData();
      setSampleInited(true);
    }
  }, [isDemoMode, sampleInited]);

  return (
    <GymInfraContext.Provider value={{ gymId, useDB, isAdminMode, isDemoMode, reloadTrigger, triggerReload }}>
      {children}
    </GymInfraContext.Provider>
  );
};

export const useGymInfra = () => {
  const ctx = useContext(GymInfraContext);
  if (!ctx) throw new Error('useGymInfra must be used within GymInfraProvider');
  return ctx;
};
